import { useQuery } from '@tanstack/react-query';
import { projectService } from '@services/project';
import { useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';

export const PROJECTS_BY_STATE_QUERY_KEY = 'projectsByState';

export const useProjectsByState = (states?: string[]) => {
  const { userId } = useAppSelector((state: RootState) => state.user);

  return useQuery({
    queryKey: [PROJECTS_BY_STATE_QUERY_KEY, userId, states],
    queryFn: () => projectService.getProjectsByUserWithStates(userId!, states),
    enabled: !!userId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
